import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { getMyProfiles } from "../endpoints/tenant-portal/my-profiles_GET.schema";
import { postSelectProfile } from "../endpoints/tenant-portal/select-profile_POST.schema";

export function useTenantProfiles(options?: { enabled?: boolean }) {
  const queryClient = useQueryClient();

  const query = useQuery({
    queryKey: ["tenant-portal", "my-profiles"],
    queryFn: () => getMyProfiles(),
    enabled: options?.enabled,
  });

  const selectProfile = useMutation({
    mutationFn: postSelectProfile,
    onSuccess: async () => {
      // Every portal view may depend on the tenant selected for this session.
      await queryClient.invalidateQueries();
    },
  });

  return { ...query, selectProfile };
}